import React, { ReactChild } from 'react';

const IcApplePay = ({ fill }): ReactChild => {
  const mainFill = fill || '#000';

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.9841 6.56607C13.542 6.56607 12.3786 7.43863 11.6272 7.43863C10.8395 7.43863 9.78515 6.61455 8.53692 6.61455C6.16164 6.61455 3.75 8.58991 3.75 12.2861C3.75 14.6008 4.64679 17.0367 5.7496 18.6243C6.68274 19.9452 7.51894 21.0359 8.70658 21.0359C9.8821 21.0359 10.4032 20.2603 11.8696 20.2603C13.3481 20.2603 13.6874 21.0117 14.9841 21.0117C16.2808 21.0117 17.1413 19.8361 17.9532 18.6727C18.85 17.3276 19.2378 16.0187 19.2499 15.9581C19.1772 15.9339 16.705 14.928 16.705 12.0922C16.705 9.64424 18.644 8.55355 18.7531 8.46872C17.4806 6.61455 15.5295 6.56607 14.9841 6.56607ZM14.3176 5.00275C14.8993 4.28774 15.3113 3.31824 15.3113 2.33662C15.3113 2.20331 15.2992 2.07001 15.275 1.96094C14.3297 1.99729 13.1663 2.59111 12.4755 3.40307C11.9423 4.02113 11.4333 5.00275 11.4333 5.98437C11.4333 6.1298 11.4575 6.28734 11.4697 6.33582C11.5303 6.34794 11.6272 6.36005 11.7242 6.36005C12.5846 6.36005 13.6753 5.77835 14.3176 5.00275Z"
        fill={mainFill}
      />
    </svg>
  );
};

export default IcApplePay;
